"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _UILoadingButton = _interopRequireDefault(require("UIComponents/button/UILoadingButton"));

var _classNames = _interopRequireDefault(require("pricing-pages-unified-ui/utils/classNames"));

var LoadingMerchCardAuthedCTAs = function LoadingMerchCardAuthedCTAs(props) {
  var _props$style = props.style,
      style = _props$style === void 0 ? {} : _props$style,
      className = props.className,
      numPurchaseMotions = props.numPurchaseMotions,
      maxPurchaseMotionsOnPage = props.maxPurchaseMotionsOnPage;
  var loadingButtonCount = Math.min(numPurchaseMotions, maxPurchaseMotionsOnPage);
  var loadingButtons = [];

  for (var i = 0; i < loadingButtonCount; i++) {
    loadingButtons.push(_react.default.createElement(_UILoadingButton.default, {
      use: "primary",
      loading: true,
      key: i,
      className: (0, _classNames.default)(i < loadingButtonCount - 1 && 'm-bottom-2', 'm-x-0')
    }, "Loading"));
  }

  return _react.default.createElement("div", {
    style: Object.assign({}, style),
    className: (0, _classNames.default)(className, 'flex-column align-center')
  }, loadingButtons);
};

var _default = LoadingMerchCardAuthedCTAs;
exports.default = _default;
module.exports = exports.default;